import Vue from 'vue'
import { DatePicker, Collapse, CollapseItem, Row, Col, Option, Select, RadioGroup, Radio, Input, Dialog, Button, Form, FormItem, Icon, Upload, Loading, Container, Message, Carousel, CarouselItem, Main, Header   } from 'element-ui'
import '../styles/element-variables.scss'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Upload)
Vue.use(Loading)
Vue.use(Container)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Main)
Vue.use(Header)
Vue.use(Dialog)
Vue.use(Input)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(Row)
Vue.use(Col)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(DatePicker)

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message